import { BaseUrl, JsonConfig } from "./BaseRepository";
import axios from 'axios';

import Cookies from "js-cookie";
const jwtToken = Cookies.get("jwt_token");
//Api request for Updating Corporate Employee data

export const UpdateCorporateExpense = async (UpdatedData) => {
    try{
        const URL = BaseUrl+"ExpenseReim/updateExpencerecordCorprate";
        const Response = await axios.put(URL, UpdatedData, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}



//Api request for Updating Corporate Employee data
export const AddNewCorporateExpense = async (NewRecord) => {
    try{
        const URL = BaseUrl+"ExpenseReim/newExpencerecordCorprate";
        const Response = await axios.post(URL, NewRecord, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}
export const AddNewGlCode = async (NewRecord) => {
    try{
        const URL = BaseUrl+"ExpenseReim/Addnewcodelist";
        const Response = await axios.post(URL, NewRecord, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}
//Api request for Updating Corporate Employee data
// export const DeleteCorporateEmployee = async (ExpId) => {
//     try{
//         const URL = BaseUrl+"ExpenseReim/RemoveCorporate?exp_id="+ExpId;
//         const Response = await axios.delete(URL, JsonConfig);
//         const JsonResponse = Response !== null ? Response.data : null;
//         return JsonResponse;
//     }
//     catch{
//         return null;
//     }
//}
export const DeleteCorporateEmployee = async (DeletableObject) => {
    try {
        console.log(DeletableObject);
      const URL = `${BaseUrl}ExpenseReim/RemoveCorporate?expencemodelid=`+DeletableObject.exp_id;
  
      const Response = await axios.delete(URL, JsonConfig);
  
      const JsonResponse = Response !== null ? Response.data : null;
      return JsonResponse;
    } catch (error) {
      console.error('Error deleting corporate employee:', error);
      return null;
    }
  };